import type { DeployParamValue_v4 } from '@redviking/argonaut-util/types/mes/applet-designs/latest/deployParam.latest.zod';
import type { DeployParamValue_v3 } from '@redviking/argonaut-util/types/mes/applet-designs/v3/deployParam.v3.zod';
import { DeployParamKind } from '../deployParam.zod';

export function upgradeDeployParamFromV3ToV4 (oldParamVal: DeployParamValue_v3): DeployParamValue_v4 {
    if (oldParamVal.kind === DeployParamKind.localVarValue) {
        return {
            ...oldParamVal,
            schemaVersion: 4,
            val: oldParamVal.val.val,
            enabled: true,
        };
    }
    return {
        ...oldParamVal,
        schemaVersion: 4,
    };
}
